import React from 'react';
import { IProps, IState } from 'components/Accordion/Item/types';

class Item extends React.Component<IProps, IState> {
  readonly state: IState = {
    active: false
  }

  componentDidUpdate(prevProps: IProps) {
    if (prevProps.isActive !== this.props.isActive) {
      this.handleUpdateActive();
    }
  }

  handleUpdateActive = () => {
    this.setState({
      active: this.props.isActive as boolean
    });
  }

  // 開啟 or 關閉 Accordion
  handleToggleAccordion = () => {
    this.props.updateStatus && this.props.updateStatus(!this.state.active);

    this.setState(state => ({ ...state, active: !state.active }));
  }

  render() {
    return (
      <div className="accordion__item">
        {React.Children.map(
          this.props.children,
          child => React.cloneElement(child as React.ReactElement<any>, {
            handleToggleAccordion: this.handleToggleAccordion,
            accordionActive: this.state.active
          })
        )}
      </div>
    );
  }
};

export default Item;
